import React, { useMemo } from 'react'
import { dialogTypes } from '@/dialogs'
import context from '@/context'
import { Column, LookupNameColumn } from '@/components/BsrsGrid'
import { PropertyRenderer } from '@/components/changeRequests'
import { useLocalization } from '@/hooks/localization'
import { institutionPermissionTypes } from '@/enums/institutionPermissionTypes'
import { PermissionSectionProvider } from '@/components/changeRequests/institutionPermissionProvider'

export const Branches = React.memo(function Branches ({ dataSource }) {
  const { localize, locale } = useLocalization()
  const detailDialog = useMemo(() => ({ dialogType: dialogTypes.branch, loadData: context.api.branchService.get }), [])
  return (
    <PermissionSectionProvider institutionPermission={institutionPermissionTypes.enum.Branches}>
      <PropertyRenderer name='branches' inputType='grid' dataSource={dataSource}
        addButtonLabel='Institutions.AddBranch'
        detailDialog={detailDialog}>
        {LookupNameColumn({ locale, field: 'branchType', title: localize('Common.Type'), editable: false, width: '200px' })}
        <Column field='code' title={localize('Common.Code')} width='200px' />
        <Column field='name' title={localize('Common.ArabicName')} />
        <Column field='latinName' title={localize('Common.LatinName')} />
        {LookupNameColumn({ locale, field: 'status', title: localize('Common.Status'), editable: false, width: '200px' })}
      </PropertyRenderer>
    </PermissionSectionProvider>
  )
})



// WEBPACK FOOTER //
// ./src/components/demographics/branches.js